<template>
  <div id="container">
    <!-- 退货信息 -->
    <return-information :params="purchaseRetreatVo"></return-information>
    <el-row>
      <el-col :span="18">
        <!-- 退货方案  -->
        <return-management
          ref="returnManagementRefs"
          :contractFrom="contractFrom"
          :state="state"
          :invoiceState="dataState.invoiceState"
          :mark="mark"
          :listContact="listContact"
          v-show="activeName=== '退货方案'"
        ></return-management>
        <!-- 物流管理 -->
        <return-logistics ref="returnLogisticsRefs" v-show="activeName=== '物流管理'"></return-logistics>
        <!-- 合同管理 -->
        <return-contact ref="returnContactRefs" v-show="activeName=== '合同管理'"></return-contact>
        <!-- 罚没金收票 -->
        <return-confiscated-gold ref="returnConfiscatedGoldRefs" v-show="activeName=== '罚没金收票'"></return-confiscated-gold>
        <!-- 退款结算 -->
        <return-money ref="returnMoneyRefs" v-show="activeName=== '退款结算'"></return-money>
      </el-col>
      <el-col :span="6">
        <div
          class="item-box-content"
          style="margin-left:20px;"
          v-for="(item,i) in oldList"
          :key="i"
        >
          <div class="title-font-style">
            <span>{{item.name}}</span>
          </div>
          <div v-if="state===1||state===2" class="maintain-scheme">{{'等待退货产品入库'}}</div>
          <el-table
            style="margin-top:20px;"
            border
            v-else-if="item.stateVal !== '无需收票' && item.stateVal !== '无需退货'"
            ref="tableRef"
            :data="[item]"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
          >
            <el-table-column :label="item.type" prop="typeVal"></el-table-column>
            <el-table-column :label="item.state" prop="stateVal"></el-table-column>
            <el-table-column label="操作">
              <template>
                <el-button type="text" @click="onDetails(item,i)">前往</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else-if="item.stateVal === '无需收票'" style="margin-top:20px;padding:27px;text-align: center;background-color: rgb(246, 247, 250);">退货任务中不存在罚没</div>
          <div v-else-if="item.stateVal === '无需退货'" style="margin-top:20px;padding:27px;text-align: center;background-color: rgb(246, 247, 250);">退货任务中不存在已发货产品</div>
        </div>
      </el-col>
    </el-row>
    <!-------------- 录入产品序列号 ------------>
    <inprouct-serial-code-dialog @inProuctSerial="inProuctSerial" ref="inProuctSerialCodeRefs"></inprouct-serial-code-dialog>
  </div>
</template>

<script>
import inProuctSerialCodeDialog from '@/views/purchase/purchaseManage/dialog/inProuctSerialCodeDialog' // 序列号
import returnInformation from './returnInformation' // 退货信息
import { deepClone } from '@/util'
import returnManagement from './returnManagement' // 退货管理
import returnLogistics from './returnLogistics' // 退货管理
import returnContact from './returnContact'// 合同管理
import returnConfiscatedGold from './returnConfiscatedGold'// 罚没金
import returnMoney from './returnMoney'// 退款结算
import {
  queryRetreatDetails
} from '@/api/purchase/purchasePlanList'
export default {
  components: {
    'inprouct-serial-code-dialog': inProuctSerialCodeDialog,
    'return-information': returnInformation,
    'return-management': returnManagement,
    'return-logistics': returnLogistics,
    'return-contact': returnContact,
    'return-confiscated-gold': returnConfiscatedGold,
    'return-money': returnMoney
  },
  data () {
    return {
      activeName: '退货方案',
      dataState: {},
      state: 1,
      oldList: [
        {
          name: '退货方案',
          type: '方案类型',
          typeVal: '销售售后退货',
          state: '退货状态',
          stateVal: '',
          info: 'salesProgram',
          status: true

        },
        {
          name: '物流管理',
          type: '物流类型',
          typeVal: '退货入库',
          state: '物流状态',
          stateVal: '',
          info: 'salesRefundLogistics',
          status: false
        },
        {
          name: '合同管理',
          type: '合同类型',
          typeVal: '销售退货合同',
          state: '合同状态',
          stateVal: '',
          info: 'salesRefundContract',
          status: false
        },
        {
          name: '罚没金收票',
          type: '收票类型',
          typeVal: '售后退货',
          state: '收票状态',
          stateVal: '',
          info: 'confiscatedInvoice',
          status: false
        },
        {
          name: '退款结算',
          type: '结算类型',
          typeVal: '售后退货',
          state: '结算状态',
          stateVal: '',
          info: 'salesRefundSettlement',
          status: false
        }
      ],
      contractFrom: '',
      purchaseRetreatVo: {},
      logisticsManagementList: [], // 物流管理列表
      flowLabel: '维修流程',
      oldListClone: [],
      list: [
        {
          title: '退货产品清单',
          arr: [{}, {}, {}]
        }

      ],
      listContact: [],
      queryParams: {},
      stepList: ['发起申请', '退货审批', '退货出库、退票、退货结算', '退货完成'],
      stepList2: ['退货出库、退票、退货结算', '退货完成'],
      stepList1: ['发起申请', '退货审批', '审核不通过'],
      detailsList: [{ num: 2 }, { num: 2 }, { num: 2 }],
      totalList: [{ num: 2 }],
      mark: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList (type) {
      queryRetreatDetails(this.$route.query.pcrId)
        .then(res => {
          if (res.data.code === 200) {
            this.dataState = res.data.obj.purchaseRetreatManageVo
            this.mark = res.data.obj.purchaseRetreatManageVo.purchaseRetreatStateVo.mark
            this.state = res.data.obj.purchaseRetreatManageVo.purchaseRetreatStateVo.state
            this.purchaseRetreatVo = res.data.obj.purchaseRetreatVo
            this.contractFrom = res.data.obj.purchaseRetreatVo.contractFrom
            this.listContact = [res.data.obj.purchaseLaunchRetreatAllVo]
            // this.oldListClone = deepClone(this.oldList)
            this.oldList = [
              {
                name: '退货方案',
                type: '方案类型',
                typeVal: '销售售后退货',
                state: '退货状态',
                stateVal: '',
                info: 'salesProgram',
                status: true

              },
              {
                name: '物流管理',
                type: '物流类型',
                typeVal: '退货入库',
                state: '物流状态',
                stateVal: '',
                info: 'salesRefundLogistics',
                status: false
              },
              {
                name: '合同管理',
                type: '合同类型',
                typeVal: '销售退货合同',
                state: '合同状态',
                stateVal: '',
                info: 'salesRefundContract',
                status: false
              },
              {
                name: '罚没金收票',
                type: '收票类型',
                typeVal: '售后退货',
                state: '收票状态',
                stateVal: '',
                info: 'confiscatedInvoice',
                status: false
              },
              {
                name: '退款结算',
                type: '结算类型',
                typeVal: '售后退货',
                state: '结算状态',
                stateVal: '',
                info: 'salesRefundSettlement',
                status: false
              }
            ]
            if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatSchemeVo.schemeState === 3) {
              this.oldList[0].stateVal = '退货中'
            } else {
              this.oldList[0].stateVal = '已完成'
            }
            if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatLogisticVo.logisticState === 0) {
              this.oldList[1].stateVal = '待出库'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatLogisticVo.logisticState === 2) {
              this.oldList[1].stateVal = '无需退货'
            } else {
              this.oldList[1].stateVal = '已出库'
            }
            if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 0) {
              this.oldList[2].stateVal = '未生成'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 1) {
              this.oldList[2].stateVal = '待签署'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 2) {
              this.oldList[2].stateVal = '上级审批中'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 3) {
              this.oldList[2].stateVal = '已签署'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 4) {
              this.oldList[2].stateVal = '审批失败'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState === 5) {
              this.oldList[2].stateVal = '已作废'
            }
            if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatInvoiceVo.invoiceState === 0) {
              this.oldList[3].stateVal = '待收票'
            } else if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatInvoiceVo.invoiceState === 2) {
              this.oldList[3].stateVal = '无需收票'
            } else {
              this.oldList[3].stateVal = '已收票'
            }
            if (res.data.obj.purchaseRetreatManageVo.purchaseRetreatPayVo.payState === 0) {
              this.oldList[4].stateVal = '未完成'
            } else {
              this.oldList[4].stateVal = '已完成'
            }
            this.oldList[0].typeVal = res.data.obj.purchaseRetreatManageVo.purchaseRetreatSchemeVo.schemeType
            this.oldList[1].typeVal = res.data.obj.purchaseRetreatManageVo.purchaseRetreatLogisticVo.logisticType
            this.oldList[2].typeVal = res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractType// 1待签署 2上级审批中 3审批通过 4审批失败 5已作废
            this.oldList[3].typeVal = res.data.obj.purchaseRetreatManageVo.purchaseRetreatInvoiceVo.invoiceType

            this.oldList[4].typeVal = res.data.obj.purchaseRetreatManageVo.purchaseRetreatPayVo.payType
            this.oldListClone = deepClone(this.oldList)

            let params
            this.oldListClone.forEach((ele, index) => {
              if (ele.name === this.$route.query.activeName) {
                params = deepClone(ele)
              }
            })
            this.oldList.splice(0, 1)
            if (this.$route.query.activeName && params.name === '合同管理') {
              this.onDetails(params)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onDetails (item, i) {
      let indexs
      this.oldList = deepClone(this.oldListClone)
      this.oldList.forEach((ele, index) => {
        if (item.name === ele.name) {
          indexs = index
          ele.status = true
        }
      })
      this.oldList.splice(indexs, 1)
      this.activeName = item.name
      if (this.activeName === '退货方案') {
        this.$route.query.isShow = undefined
        this.$route.query.activeName = undefined
        this.getList(1)
      } else if (this.activeName === '物流管理') {
        this.$refs.returnLogisticsRefs.getList()
      } else if (this.activeName === '合同管理') {
        if (this.$route.query.activeName && this.$route.query.isShow) {
          this.$refs.returnContactRefs.getList(1)
        } else {
          this.$refs.returnContactRefs.getList()
        }
      } else if (this.activeName === '罚没金收票') {
        this.$refs.returnConfiscatedGoldRefs.getList()
      } else if (this.activeName === '退款结算') {
        this.$refs.returnMoneyRefs.getList()
      }
    },
    // 序列号传回来的值
    inProuctSerial (val, i) {
      this.list[3].arr[i].serialCode = val
    },
    // 点击录入
    onEntering (val, i) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, i, 0)
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 1) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (rowIndex === 2) {
          return {
            rowspan: 2,
            colspan: 0
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.maintain-scheme {
  height: 136px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 136px;
  margin-top: 20px;
}
.text-box {
  margin-bottom: 20px;
  font-weight: 500;
  line-height: 21px;
  color: #83878a;
  font-size: 12px;
}
.title {
  margin: 30px 0 14px;
  .ht {
    font-size: 16px;
    font-weight: bold;
    color: #4e555b;
  }
  .text {
    margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
.title-text {
  margin: 20px 0 14px;
  .text-title {
    // margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
.maintain-scheme {
  height: 80px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 80px;
  margin-top: 20px;
}
</style>
